import { render, staticRenderFns } from "./FileUploadDocumentItem.vue?vue&type=template&id=27d33b56&scoped=true&"
import script from "./FileUploadDocumentItem.vue?vue&type=script&lang=js&"
export * from "./FileUploadDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadDocumentItem.vue?vue&type=style&index=0&id=27d33b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d33b56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
